import './telematicsVideo.css';
import video from '../../../assets/images/video-2.jpg'
import {format} from "date-fns";
import {useEffect, useState} from "react";
import Video from "../../../shared/video/video";
const TelematicsVideo = ({handleShowVideoPlayer, video}) => {
    const [alertName, setAlertName] = useState('')
    const showVideoPlayer = (video) => {
        handleShowVideoPlayer(true, video);
        // window.scroll({
        //     top: 0,
        //     behavior: 'smooth'
        // });
    }

    const userDetails = JSON.parse(localStorage.getItem("user-details"));
    const getCurrentAlertName = () => {
        const currentAlert = userDetails?.skuDetails
            ?.alerts?.filter((alert) => alert.alertString === video?.alertType);
        setAlertName(currentAlert[0]?.alertShortString);
    }

    useEffect(() => {
        getCurrentAlertName();
    }, [])


    return(
        <li className={`telematics-video ${video?.status === 'AVAILABLE' ? 'not-seen' : ''}`}
            onClick={e => showVideoPlayer(video)}>
            <div className={'video-thumb  margin-b-10'}>
                <Video isThumb={true} videoLink={video?.preSignedUrl}/>
            </div>
            <div className="font-14">
                <div className="telematics-video-details flex gap-10 sf-medium margin-b-10">
                    <div className={`rating-box ${video?.alertType}`}>{alertName}</div>
                    <div className="font-15 date">
                        <span className={'margin-r-15'}>{format(new Date(video?.videoStartTime), 'HH:mm')}</span>
                        {format(new Date(video?.videoStartTime), 'dd LLL yyyy')}
                    </div>
                </div>
                <ul className="separator gap-30 sf-bold margin-b-10">
                    <li>{video.plateNo}</li>
                    {/*<li>Driver:  <span className={'blue-color'}>Babu K</span></li>*/}
                </ul>
                {/*<div className="grey-color sf-medium">Eicher/HMV    Chennai - Ahmedabad</div>*/}
            </div>
        </li>
    )
}

export default TelematicsVideo;
